import { makeAutoObservable, observable } from 'mobx';
class ConfirmDiscardingChangesDialogStore {
  isChangingTabsAllowed = true;
  isWarningDialogOpened = false;
  isDiscardChangesAllowed = false;
  navigationAfterConfirmation: string = '';

  constructor() {
    makeAutoObservable(this, { isChangingTabsAllowed: observable, isWarningDialogOpened: observable, isDiscardChangesAllowed: observable });
  }

  // set is changing tabs allowed
  setIsChangingTabsAllowed(isChangingTabsAllowed: boolean) {
    this.isChangingTabsAllowed = isChangingTabsAllowed;
  }

  // set navigation after confirmation
  setNavigationAfterConfirmation(navigationAfterConfirmation: string) {
    this.navigationAfterConfirmation = navigationAfterConfirmation;
  }

  // displayConfirmationDialog for discarding unsaved changes
  displayConfirmationDialog(isDialogOpened) {
    this.isWarningDialogOpened = isDialogOpened;
    this.isDiscardChangesAllowed = false;
  }

  confirmDiscardChanges() {
    this.isDiscardChangesAllowed = true;
    this.isWarningDialogOpened = false;
    this.isChangingTabsAllowed = true;
  }

  cancelDiscardChanges() {
    this.isDiscardChangesAllowed = false;
    this.isWarningDialogOpened = false;
  }

  resetConfirmationDialogStore() {
    this.isChangingTabsAllowed = true;
    this.isWarningDialogOpened = false;
    this.isDiscardChangesAllowed = false;
    this.navigationAfterConfirmation = '';
  }
}

export default ConfirmDiscardingChangesDialogStore;
